<template>
    <input id="js-datepicker" class="AlgoliaEventsDateFilter__date" :placeholder="placeholder">
</template>
<script>
import flatpickr from 'flatpickr';
export default {
    name: 'DatePicker',
    data: () => ({
        instance: null
    }),
    props: {
        initOptions: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            default: 'Select date'
        }
    },
    mounted() {
        const el = document.querySelector('#js-datepicker');
        this.instance = flatpickr(el, {
            ...this.initOptions,
            formatDate: this.formatDate,
            onChange: this.handleChange
        });
        this.$emit('mounted', this.instance);
    },
    methods: {
        formatDate(date) {
            return flatpickr.formatDate(date, 'j M y');
        },
        handleChange(dates) {
            this.$emit('change', dates.map((d) => flatpickr.formatDate(d, 'U')));
        }
    }
}
</script>
<style lang="scss">
    .flatpickr-calendar .numInputWrapper {
        .arrowUp, .arrowDown {
            border: none;
            opacity: 1;
        }

        .arrowDown {
            top: 35%;
            margin-top: 3px;

            &:after {
                top: 20%;
            }
        }

        .arrowUp:after{
            border-left-width: 4px;
            border-right-width: 4px;
            border-bottom-width: 7px;
        }

        .arrowDown:after  {
            border-left-width: 4px;
            border-right-width: 4px;
            border-top-width: 7px;
        }
    }

    .flatpickr-monthDropdown-months {
        line-height: 1.4 !important;
    }

    .flatpickr-calendar.open {
        z-index: 500;
    }

</style>
